import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="bg-[#1A1A2E] text-white mt-10" role="contentinfo">
      <div className="max-w-[1280px] mx-auto px-5 py-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-8">
          <div className="col-span-2 md:col-span-1">
            <div className="text-[22px] font-extrabold text-[#FF5277] mb-2">SGGadgets</div>
            <p className="text-[13px] text-white/60 leading-relaxed">
              Your one-stop shop for the latest tech gadgets and accessories in Singapore. Quality products, competitive prices, and fast delivery across the island.
            </p>
            <div className="flex gap-3 mt-4">
              <span className="text-xl cursor-pointer hover:opacity-80 transition-opacity">📘</span>
              <span className="text-xl cursor-pointer hover:opacity-80 transition-opacity">📸</span>
              <span className="text-xl cursor-pointer hover:opacity-80 transition-opacity">🐦</span>
              <span className="text-xl cursor-pointer hover:opacity-80 transition-opacity">📺</span>
            </div>
          </div>

          <div>
            <div className="text-[14px] font-bold mb-4">Shop</div>
            <ul className="space-y-2">
              {[
                { name: 'All Categories', href: '/shop' },
                { name: 'Mobile Accessories', href: '/category/smartphones' },
                { name: 'Audio', href: '/category/audio' },
                { name: 'Computer', href: '/category/laptops' },
                { name: 'Wearables', href: '/category/wearables' },
                { name: 'Smart Home', href: '/category/smart-home' },
              ].map((link) => (
                <li key={link.name}>
                  <Link to={link.href} className="text-[13px] text-white/60 hover:text-[#FF5277] transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-[14px] font-bold mb-4">Support</div>
            <ul className="space-y-2">
              {[
                { name: 'Help Center', href: '/faq' },
                { name: 'Shipping Info', href: '/shipping-policy' },
                { name: 'Returns & Refunds', href: '/return-policy' },
                { name: 'Track Order', href: '/track-order' },
                { name: 'Contact Us', href: '/contact' },
                { name: 'FAQ', href: '/faq' },
              ].map((link) => (
                <li key={link.name}>
                  <Link to={link.href} className="text-[13px] text-white/60 hover:text-[#FF5277] transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-[14px] font-bold mb-4">Company</div>
            <ul className="space-y-2">
              {[
                { name: 'About Us', href: '/about' },
                { name: 'Careers', href: '/about' },
                { name: 'Privacy Policy', href: '/privacy-policy' },
                { name: 'Terms of Service', href: '/terms' },
                { name: 'Seller Center', href: '/login' },
                { name: 'Affiliate Program', href: '/about' },
              ].map((link) => (
                <li key={link.name}>
                  <Link to={link.href} className="text-[13px] text-white/60 hover:text-[#FF5277] transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-5 text-center text-[12px] text-white/40">
          <p>© 2026 SGGadgets.com. All rights reserved. | Made with ❤️ in Singapore 🇸🇬</p>
          <p className="mt-1">PayNow | Visa | Mastercard | PayPal | GrabPay</p>
        </div>
      </div>
    </footer>
  );
}
